module.exports = __webpack_public_path__ + "static/media/logoNew2.65b4716b.png";